import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted, computed } from 'vue'

  interface Props {
    message: string[]
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'type-write-animation',
  props: {
    message: {}
  },
  setup(__props: any) {

  const props = __props
  const typeWriteElement = ref<HTMLElement | null>(null)
  const word = ref('_')

  const txtType = function(toRotate, delay , loopNum, isDeleting) {
    var i = loopNum % toRotate.length;
    var fullTxt = toRotate[i];
    var txt = word.value;
  
    if (isDeleting) {
      txt = fullTxt.substring(0, txt.length - 1);
    } else {
      txt = fullTxt.substring(0, txt.length + 1);
    }

    word.value = txt

    var delta = 100;//getRandomArbitrary(150, 250);
  
    if (isDeleting) { delta /= 3; }
  
    if (!isDeleting && txt === fullTxt) {
      delta = 300;
      isDeleting = true;
    } else if (isDeleting && txt === '') {
      delta = 300;
      isDeleting = false;
      loopNum++;
    }
  
    setTimeout(function() {
      txtType(toRotate, delay, loopNum, isDeleting)
    }, isDeleting && txt === fullTxt ? delay : delta );
  };

  function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }

  onMounted( ()  => {
    txtType(props.message, 3000, 0, false);
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    ref_key: "typeWriteElement",
    ref: typeWriteElement,
    class: "type-write-animation--component"
  }, _toDisplayString(word.value), 513))
}
}

})